export const DeliveryChallanUnits: any = [
    {
        dispatch_unit_id: 1,
        delivery_unit_name: "PCS",
    }   ,
    {
        dispatch_unit_id: 2,
        delivery_unit_name: "KG",
    }  
]